import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"   
import { ENDPOINT } from "constants/variables"; 
import Box from '@mui/material/Box';    
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";  
import ReportTemplateFirst from 'pages/shipping/filterShipping/ShippingFormDIView/ReportTemplateFirst';
import ReportTemplateSecond from 'pages/shipping/filterShipping/ShippingFormDIView/ReportTemplateSecond';
import PropTypes from 'prop-types';
import { addFormDIDecaQrToPdf } from 'pages/forms/pdf/formDIDecaQr';
import { fetchShippingDecaQr } from 'pages/shipping/deca/addDecaQrToShippingPdf';
  
const initialStateForm = {
  id: 0,
  ownformdi_id:0,
  defaultStore_id: 0,
  useraccount_id: 0, 
  defaultformatnumber: 1,
  isFinished: true,
  isScanned: false,
  numberDI_sheet: "", 
  date_sheet: "",
 
  opt_tras_documnettype: "",
  opt_tras_documentid: "",
  opt_tras_name: "",
  opt_tras_contactname: "", 
  opt_tras_cnae: "",
  opt_tras_nima: "",
  opt_tras_country: "",
  opt_tras_province: "",
  opt_tras_locality: "",
  opt_tras_community: "",
  opt_tras_phone: "",
  opt_tras_licenseplate: "",
  opt_tras_economicactivity: "",
  opt_tras_tradename: "",
  opt_tras_street: "",
  opt_tras_postalcode: "",
  opt_tras_email: "",
  opt_tras_inscription: "",
  opt_tras_opt: "",
  
  ori_tras_documnettype: "",
  ori_tras_documentid: "",
  ori_tras_name: "",
  ori_tras_contactname: "", 
  ori_tras_cnae: "",
  ori_tras_nima: "",
  ori_tras_country: "",
  ori_tras_province: "",
  ori_tras_locality: "",
  ori_tras_community: "",
  ori_tras_phone: "",
  ori_tras_licenseplate: "",
  ori_tras_economicactivity: "",
  ori_tras_tradename: "",
  ori_tras_street: "",
  ori_tras_postalcode: "",
  ori_tras_email: "",
  ori_tras_inscription: "",
  ori_tras_opt: "",

  aut_tras_documnettype: "",
  aut_tras_documentid: "",
  aut_tras_name: "",
  aut_tras_contactname: "", 
  aut_tras_cnae: "",
  aut_tras_nima: "",
  aut_tras_country: "",
  aut_tras_province: "",
  aut_tras_locality: "",
  aut_tras_community: "",
  aut_tras_phone: "",
  aut_tras_licenseplate: "",
  aut_tras_economicactivity: "",
  aut_tras_tradename: "",
  aut_tras_street: "",
  aut_tras_postalcode: "",
  aut_tras_email: "",
  aut_tras_inscription: "",
  aut_tras_opt: "",
 
  dest_tras_documnettype: "",
  dest_tras_documentid: "",
  dest_tras_name: "",
  dest_tras_contactname: "", 
  dest_tras_cnae: "",
  dest_tras_nima: "",
  dest_tras_country: "",
  dest_tras_province: "",
  dest_tras_locality: "",
  dest_tras_community: "",
  dest_tras_phone: "",
  dest_tras_licenseplate: "",
  dest_tras_economicactivity: "",
  dest_tras_tradename: "",
  dest_tras_street: "",
  dest_tras_postalcode: "",
  dest_tras_email: "",
  dest_tras_inscription: "",
  dest_tras_opt: "",
  
  aut_dest_documnettype: "",
  aut_dest_documentid: "",
  aut_dest_name: "",
  aut_dest_contactname: "", 
  aut_dest_cnae: "",
  aut_dest_nima: "",
  aut_dest_country: "",
  aut_dest_province: "",
  aut_dest_locality: "",
  aut_dest_community: "",
  aut_dest_phone: "",
  aut_dest_licenseplate: "",
  aut_dest_economicactivity: "",
  aut_dest_tradename: "",
  aut_dest_street: "",
  aut_dest_postalcode: "",
  aut_dest_email: "",
  aut_dest_inscription: "",
  aut_dest_opt: "",
  
  rel_trans_documnettype: "",
  rel_trans_documentid: "",
  rel_trans_name: "",
  rel_trans_contactname: "", 
  rel_trans_cnae: "",
  rel_trans_nima: "",
  rel_trans_country: "",
  rel_trans_province: "",
  rel_trans_locality: "",
  rel_trans_community: "",
  rel_trans_phone: "",
  rel_trans_licenseplate: "",
  rel_trans_economicactivity: "",
  rel_trans_tradename: "",
  rel_trans_street: "",
  rel_trans_postalcode: "",
  rel_trans_email: "",
  rel_trans_inscription: "",
  rel_trans_opt: "",
 
  resp_prod_documnettype: "",
  resp_prod_documentid: "",
  resp_prod_name: "",
  resp_prod_contactname: "", 
  resp_prod_cnae: "",
  resp_prod_nima: "",
  resp_prod_country: "",
  resp_prod_province: "",
  resp_prod_locality: "",
  resp_prod_community: "",
  resp_prod_phone: "",
  resp_prod_licenseplate: "",
  resp_prod_economicactivity: "",
  resp_prod_tradename: "",
  resp_prod_street: "",
  resp_prod_postalcode: "",
  resp_prod_email: "",
  resp_prod_inscription: "",
  resp_prod_opt: "",

  codeLER: "",
  codeLER_code: "",
  codeLER_name: "",
  description: "",
  description_code: "",
  description_name: "",
  treatmenttypeorigin_code: "",
  treatmenttypeorigin_name: "",
  treatmenttypedestine_code: "",
  treatmenttypedestine_name: "",
  processtypepeorigin_code: "",
  processtypepeorigin_name: "",
  processtypedestine_code: "",
  processtypedestine_name: "",
  dangerousness_name: "",
  charac_danger: "",
  amount: "",
  deliver_date: "",
  delivery_quantity: "",
  date_accepted: "",
  accept: "",
  date_refund: "",
  reason_refund: "",
  action_refund: "",
  observations1: "",
  observations2: "" ,
  
  signature_opt_tras:"",
  signature_dest_tras:"",
  signature_refund:""  ,
  end_date_sheet:"",
  widevalidity:false 
  
};
 

const FormDIView = ({ openViewFormDI, setOpenViewFormDI,rowEditShipping}) => {
  const { t, i18n } = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);  
  const [dataForm, setDataForm] = useState(initialStateForm);
  const [isLoadingErrorFormDI, setIsLoadingErrorFormDI] = useState(false);
  const isLoading = useSelector((state) => state.loading.isLoading);    
  const [pdfBlob, setPdfBlob] = useState(null); 
  const [pdfUrl, setPdfUrl] = useState(""); // Estado para actualizar el PDF

  const dispatch = useDispatch(); 

  const setPdfWithShippingDeCAQr = useCallback(async (pdf) => {
    if (!pdf) {
      setPdfBlob(null);
      return;
    }
    const qrDataUrl = await fetchShippingDecaQr(rowEditShipping.id, token);
    setPdfBlob(await addFormDIDecaQrToPdf(pdf, qrDataUrl));
  }, [rowEditShipping.id, token]);
   
  const handleCloseDataViewShipping = () => {
    setDataForm(initialStateForm);
    setIsLoadingErrorFormDI(false);
    dispatch(setLoading(false));    
    setPdfBlob(null);
    setPdfUrl("");
    setOpenViewFormDI(false)
	};
   
  const PdfViewer = useMemo(() => {
      return pdfUrl?
        <iframe
          src={pdfUrl} 
          title="PDF Preview"
          style={{ width: '100%', height: '100%', border: 'none' }}
        /> 
      :pdfBlob ? (
        <iframe
          src={URL.createObjectURL(pdfBlob)}
          title="PDF Preview"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      ) : null;
    }, [pdfBlob,pdfUrl]);
  
  useEffect(() => {
    let isMounted = true;  
    const fetchFileForm = async (fileName) => {
        try {
        const getData = await helpHttp().getfilesupload(ENDPOINT, `pdftos3uploader/downloadfroms3`, token,fileName);
        if (!getData) { 
          setPdfUrl("");
          dispatch(warningErrorAction(t('Text_ConnectionFailed'))); 
        } else{ 
          if (getData && getData.size>0){
            setPdfUrl("");
            await setPdfWithShippingDeCAQr(getData);
          } 
        }
      } catch (error) {
        setPdfUrl("");
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    const fetchDataFormDI = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get8(ENDPOINT, `form/getpdfformdibyid`, token, rowEditShipping.formdi_id, defaulttypesdi);
        if (getData.err) {
          setDataForm(initialStateForm); 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataForm(getData);
          if (getData.isScanned){
            setPdfBlob(null)
            let fileName = "DI_"+getData.numberDI_sheet+ ".pdf"; 
            fetchFileForm(fileName); 
          } 
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    if (rowEditShipping.formdi_id && rowEditShipping.formdi_id!=="" && rowEditShipping.formdi_id!=="0" && rowEditShipping.formdi_id!==0){
      if (!dataForm.id || dataForm.id==="" || dataForm.id==="0" || dataForm.id===0){
        fetchDataFormDI(); 
        dispatch(setLoading(false));
      }
    }else{
      setDataForm(initialStateForm); 
      dispatch(setLoading(false));
    }
    return () => {isMounted = false;};
  }, [defaulttypesdi,rowEditShipping.formdi_id, dataForm.id,dispatch, t, token,i18n.language,setPdfWithShippingDeCAQr]);  
  
  const toggleDrawerSearchFormDI  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataViewShipping();
    }
  }; 

  return(
    <>
      {openViewFormDI && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormDI(false)}
            onOpen={toggleDrawerSearchFormDI(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff', width: '1150px'}}>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                  {isLoadingErrorFormDI?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoading?<CircularProgress color={"primary"}/>:<i className="fas fa-regular fa-clipboard text-warning"></i>} {t('Text_FORM_NUM_DI')+": "+dataForm.numberDI_sheet}</h1>
                     <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataViewShipping} >{t('Button_Back')}</button><> </>
                    </div>  
                </div>  
                <br/>  
                {!isLoading ?
                  <>
                   
                    {/* PDF CARD */}
                    <div className="email-card-pdf">
                      {PdfViewer}
                    </div>
                     
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                } 
              </Box>

              {dataForm && !dataForm.isScanned && (defaulttypesdi===1 ?
                <ReportTemplateFirst dataForm={dataForm} setPdfBlob={setPdfWithShippingDeCAQr}/>:
                <ReportTemplateSecond dataForm={dataForm} setPdfBlob={setPdfWithShippingDeCAQr}/>)}

            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

FormDIView.propTypes = {
  openViewFormDI: PropTypes.bool.isRequired,
  setOpenViewFormDI: PropTypes.func.isRequired 
};

export default FormDIView;
